export const docPaths = {
    // APPS
    button: "all/topics/components/buttons/button",
    buttonBar: "all/topics/components/buttons/button-bar",
    formButton: "all/topics/components/buttons/form-button",
    text: "all/topics/components/text",
    buyButton: "all/topics/components/buttons/buy",
    comments: "all/topics/components/lists/comments",
    compoundAction: "all/topics/actions/custom-actions",
    dateField: "all/topics/components/pickers/date",
    dateTimeField: "all/topics/components/pickers/date-time",
    emailField: "all/topics/components/input/email-entry",
    email: "all/topics/components/buttons/email",
    favorite: "all/topics/components/buttons/favorite",
    filePicker: "all/topics/components/pickers/file-picker",
    hint: "all/topics/components/text/hint",
    imagePicker: "all/topics/components/pickers/image-picker",
    image: "all/topics/components/media/image",
    addRelationColumn: "all/product/data-editor/relations",
    inlineList: "all/topics/components/lists/inline-list",
    like: "all/topics/components/pickers/like-dislike",
    link: "all/topics/components/buttons/link",
    listReference: "all/topics/components/lists/list-relation",
    locationEntry: "all/topics/components/pickers/location-component",
    mapImage: "all/topics/components/media/map",
    notes: "all/topics/components/input/notes",
    numberField: "all/topics/components/input/number-field",
    phoneField: "all/topics/components/input/phone-field",
    phoneNumber: "all/topics/components/buttons/phone",
    actionText: "all/topics/components/text/action-text",
    progress: "all/topics/components/charts/progress-bar",
    rating: "all/topics/components/pickers/rating",
    reaction: "all/topics/components/pickers/reaction",
    reference: "all/topics/components/buttons/relation",
    signature: "all/topics/components/input/signature-component",
    simpleTable: "all/topics/components/layout/basic-table",
    stopwatch: "all/topics/components/input/stopwatch",
    textField: "all/topics/components/input/text-field",
    title: "all/topics/components/layout/title",
    toggle: "all/topics/components/buttons/switch",
    compoundComponent: "", // REALLY DEPRECATED
    userProfile: "all/topics/security-and-user-data/user-profiles",
    webview: "all/topics/components/media/webview-component",
    youtube: "", // DEPRECATED
    choice: "all/topics/components/pickers/choice",
    rowIDConfig: "all/topics/data-editor/computed-columns/row-ids",
    userSpecificColumns: "all/topics/data-editor/user-specific-columns",
    protectedColumns: "all/topics/security-and-user-data/protected-columns",
    stripeFeesLearnMore: "all/topics/components/buttons/buy",
    dataLimits: "all/topics/faq/limits-on-free-apps",
    filters: "all/topics/design-and-structure/filter",
    tabVisibility: "all/topics/conditions/tab-visibility",
    templatePrivateInfo: "all/topics/templates/copy-app-as-template",
    CAARecords: "all/topics/account/apps/configuring-a-custom-domain",
    DNSStep2: "all/topics/account/apps/configuring-a-custom-domain",
    DNSStep3: "all/topics/account/apps/configuring-a-custom-domain",
    roles: "all/topics/security-and-user-data/user-profiles/roles",
    supportCodes: "all/topics/account/support/support-codes",
    scanInstall: "all/start-here/quick-start#add-the-app-to-your-home-screen",
    publishYourApp: "all/start-here/quick-start",
    eventPicker: "all/topics/components/pickers/event-picker",
    separator: "all/topics/components/layout/separator",
    audioPlayer: "all/topics/components/media/audio",
    videoPlayer: "all/topics/components/media/video",
    markdown: "all/topics/components/text/rich-text",
    yesCode: "all/topics/computed-columns/primary/experimental-code-column",
    yesCodeCaveats: "all/topics/computed-columns/primary/experimental-code-column#caveats",

    // PAGES
    pagesHint: "all/topics/components/components-pages/text-pages/hint-pages",
    pagesButton: "all/topics/components/buttons/button",
    pagesTitle: "all/topics/components/components-pages/content-pages/title-pages",
    pagesButtons: "all/topics/components/components-pages/actions-pages/button-block",
    pagesBreadcrumbs: "all/topics/components/components-pages/actions-pages/breadcrumbs-pages",
    pagesFields: "all/topics/components/components-pages/content-pages/fields-pages",
    pagesRichText: "all/topics/components/text/rich-text",
    pagesBigNumbers: "all/",
    pagesImage: "all/courses/introduction-to-pages/components-pages/content-pages/images-video-pages",
    pagesVideo: "all/courses/introduction-to-pages/components-pages/content-pages/images-video-pages",
    pagesSeparator: "all/topics/components/layout/separator",
    pagesCardCollection: "all/courses/introduction-to-pages/components-pages/content-pages/collection-pages",
    pagesContactForm: "all/courses/introduction-to-pages/components-pages/forms-pages/contact-form",
};

export type Doc = keyof typeof docPaths;

export function getDocURL(target: Doc): string {
    return "https://docs.glideapps.com/" + docPaths[target];
}
